<template>
  <div class="input-serach">
    <flex
      align="center"
      class="search-input">
      <flex
        align="center"
        class="input-wrapper">
        <el-autocomplete
          v-model="keyWord"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          :placeholder="searchHint || '请输入关键字'"
          style="height: 100%;"
          class="home-input"
          @keyup.enter.native="searchByKeyWord"
          @select="handleSelect">
          <template slot-scope="{ item }">
            <span class="addr">{{ item }}</span>
          </template>
        </el-autocomplete>
        <flex
          justify="center"
          align="center"
          class="search-icon"
          @click="searchByKeyWord">
          <img
            src="@/static/img/home/search-icon-white.png">
          搜索
        </flex>
      </flex>
      <flex
        align="center"
        justify="center"
        class="type"
        @click="showHighSearch">
        高级搜索
      </flex>
    </flex>
    <div class="hot-search">
      <span class="hot-search-item">热门搜索：</span>
      <span
        v-for="(item, index) in hotWrods"
        :key="index"
        :title="item"
        class="hot-search-item hot-words"
        @click="handleSelect(item)">
        {{ item }}
      </span>
    </div>
    <main-dialog
      :dialog-visible.sync="highSearchShow"
      :to-body="true"
      width="850px"
      top="20vh"
      title="高级搜索">
      <high-search
        @high-search="searchByHigh"/>
    </main-dialog>
  </div>
</template>

<script>
import HighSearch from '../Search/HighSearch.vue'
import * as api from '@/api/index'
import Flex from '../Common/Flex.vue'

export default {
  components: {
    HighSearch,
    Flex
  },
  data () {
    return {
      suggest: [], // 搜索建议
      keyWord: '', // 关键字
      hotWrods: [], // 热门搜索
      searchHint: '', // 搜索底纹
      highSearchShow: false,
      highSearch: {}
    }
  },
  computed: {
    highSearchQuery () {
      return this.$route.query.highSearchShow
    }
  },
  mounted () {
    if (this.highSearchQuery === '1') {
      this.highSearchShow = true
      this.$router.replace({
        path: 'home',
        query: {
          ...this.$options.filters.keepURLParams(this)
        }
      })
    }
    this.getSearchInfo()
  },
  methods: {
    // 获取搜索底纹和热搜
    getSearchInfo () {
      Promise.all([api.getSearcjHint(), api.getHotSearch({
        startTime: Math.ceil((+new Date() - 30 * 3600 * 24 * 1000) / 1000),
        stopTime: Math.ceil(+new Date() / 1000)
      })]).then(([hint, hot]) => {
        this.searchHint = hint.data || ''
        this.hotWrods = (hot.data && hot.data.length) ? hot.data.slice(0, 5) : []
      })
    },
    // 获取搜索建议
    querySearch (queryString, cb) {
      api.getSearchSuggest(queryString).then(res => {
        this.suggest = res.data || []
        cb(this.suggest)
      })
    },
    // 搜索触发的方法
    searchByKeyWord () {
      if (!this.keyWord) {
        this.keyWord = this.searchHint
        if (!this.keyWord) {
          this.$notify.warning({
            title: '警告',
            message: '请输入关键字',
            duration: 1500
          })
          return
        }
      }
      this.$emit('search-by-keyword', this.keyWord)
    },
    // 选择搜索建议
    handleSelect (keyword) {
      this.keyWord = keyword
      this.$emit('search-by-keyword', this.keyWord)
    },
    showHighSearch () {
      this.highSearchShow = true
    },
    // 高级搜索
    searchByHigh (search) {
      this.highSearch = search
      this.highSearchShow = false
      localStorage.setItem('highSearch', JSON.stringify(search))
      this.$router.replace({
        path: '/list',
        query: {
          ...this.$options.filters.keepURLParams(this)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.input-serach
  position: absolute
  left 50%
  transform translateX(-50%)
  top 250px
  width 58%
  background rgba(0, 0, 0, 0.4)
  box-shadow 0px 3px 8px 0px #2c2c2c
  padding 35px 30px 20px 30px
  box-sizing border-box
  border-radius 5px
  font-size 22px

.input-wrapper
  width 100%
  box-sizing border-box
  border-radius 4px 0px 0px 4px
  height 60px

  .search-icon
    width 130px
    height 100%
    cursor pointer
    border-radius 0px 4px 4px 0px
    background #CF1922
    color #fff
    img
      width 20px
      height 20px
      margin-right 10px

  .home-input
    width calc(100% - 150px)
    height 100%

.type
  cursor pointer
  width 168px
  height 60px
  flex none
  border-radius 4px
  padding 8px 25px
  box-sizing border-box
  font-size 22px
  background-color #CF1922
  color #fff

.hot-search
  width 100%
  margin-top 16px
  text-align left
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  font-size 12px

.hot-search-item
  flex none
  cursor pointer
  margin-left 12px
  font-size 20px
  line-height 28px
  color #fff
  &:first-child
    margin 0px

.hot-words
  &:hover
    opacity 0.8
    color #CF1922
    font-weight bold
</style>

<style lang="stylus">
.home-input
  .el-input__inner
    height 60px !important
    font-size 20px
</style>
